export default "__VITE_ASSET__sffInmfq__"